module.exports = __webpack_public_path__ + "static/m_solution3-15899747a791682b7d589e3b4378a09d.png";